import React, { useEffect } from 'react';
import classNames from 'classnames';

import SEO from '../components/SEO';

const nsBase = 'page';
const ns = `${ nsBase }-reviews`;

const ReviewsPage = () => {
	useEffect(() => {
		if (window.yotpoWidgetsContainer) {
			window.yotpoWidgetsContainer.initWidgets();
		}
	});

	const rootClassnames = classNames({
		[`${ nsBase } ${ ns }`]: true,
	});

	useEffect(() => {
		const script = document.createElement('script');
		script.innerHTML = `(function e(){var e=document.createElement("script");e.async=1, e.src="https://cdn-widgetsrepository.yotpo.com/v1/loader/${ process.env.GATSBY_YOTPO_APP_KEY }";var t=document.getElementsByTagName("script")[0]; t.parentNode.insertBefore(e,t)})();`;
		document.body.appendChild(script);
		return () => {
			document.body.removeChild(script);
		};
	}, []);

	return (
		<div className={rootClassnames}>
			<SEO
				hidden={1}
			/>
			<h1 style={{ textAlign: 'center' }}>Reviews</h1>
			<div className={'yotpo-widget-instance'} data-yotpo-instance-id={'671540'} />
		</div>
	);
};

export default ReviewsPage;
